import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PhoneInput from 'react-phone-number-input';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  VisibilityIcon,
  VisibilityOffIcon,
  LockIcon,
  EmailIcon,
} from "../../data/icons";
import { url } from "../../data/url";

const EmployerProfilePage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    currentPassword: "",
    newPassword: "",
    jobTitle: "",
    companyName: "",
    companyURL: "",
    glassdoorURL: "",
    linkedinURL: "",
  });

  const [profileImage, setProfileImage] = useState(null);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  useEffect(() => {
    fetchProfileData();
  }, []);

  const showToast = (message, type = "success") => {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      className: `custom-toast custom-toast-${type}`,
      bodyClassName: "custom-toast-body",
      progressClassName: "custom-toast-progress",
    });
  };

  const fetchProfileData = async () => {
    try {
      const response = await axios.get(`${url.path}/employer/profile-settings`);
      setFormData(prevState => ({
        ...prevState,
        firstName: response.data.firstName || "",
        lastName: response.data.lastName || "",
        email: response.data.email || "",
        phoneNumber: response.data.phoneNumber || "",
        jobTitle: response.data.jobTitle || "",
        companyName: response.data.companyName || "",
        companyURL: response.data.companyURL || "",
        glassdoorURL: response.data.glassdoorURL || "",
        linkedinURL: response.data.linkedinURL || "",
        currentPassword: "",
        newPassword: "",
      }));
      setProfileImage(response.data.profileImage || null);
    } catch (error) {
      if(error.response && error.response.status === 401) {
        navigate('/login');
      }
      console.error("Error fetching profile data:", error);
      showToast("Error fetching profile data", "error");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // const urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;

    if (!emailRegex.test(formData.email)) {
      showToast("Invalid email format", "error");
      return false;
    }

    // const urlFields = ['companyURL', 'glassdoorURL', 'linkedinURL'];
    // for (const field of urlFields) {
    //   if (formData[field] && !urlRegex.test(formData[field])) {
    //     showToast(`Invalid ${field} format`, "error");
    //     return false;
    //   }
    // }

    return true;
  };

  const handleSaveChanges = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await axios.put(`${url.path}/employer/profile-settings`, formData);
      if (response.data.message === "Profile updated successfully") {
        showToast("Profile updated successfully");
        setFormData(prev => ({ ...prev, currentPassword: "", newPassword: "" }));
      } 
    } catch (error) {
      console.log(error);
      if (error.response.data.message === "Current password is incorrect") {
        showToast("Invalid password", "error");
      }
      else {
      console.error("Error updating profile:", error);
      showToast("Error updating profile", "error");
      }
    }
  };

  const handleDeleteImage = async () => {
    if(profileImage)
    {
      try {
        await axios.delete(`${url.path}/employer/profile-settings/image`);
        setProfileImage(null);
        showToast("Profile image deleted successfully");
      } catch (error) {
        console.error("Error deleting profile image:", error);
        showToast("Error deleting profile image", "error");
      }
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      showToast("Please upload an image file", "error");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      showToast("File size should be less than 5MB", "error");
      return;
    }

    // const formData = new FormData();
    // formData.append("profileImage", file);

    // try {
    //   const response = await axios.put(`${url.path}/employer/profile-settings/image`, formData, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   });
    //   setProfileImage(response.data.imageUrl);
    //   showToast("Profile image uploaded successfully");
    // } catch (error) {
    //   console.error("Error uploading profile image:", error);
    //   showToast("Error uploading profile image", "error");
    // }
    console.log("Image Uploaded");
  };

  const togglePasswordVisibility = (field) => {
    if (field === "currentPassword") {
      setShowCurrentPassword(!showCurrentPassword);
    } else if (field === "newPassword") {
      setShowNewPassword(!showNewPassword);
    }
  };

  return (
    <div className="profile-settings">
      <ToastContainer />
      <div className="profile-settings-container">
        <h1>Account</h1>

        <div className="profile-picture-section">
          <div className="profile-picture-info-contanier">
            <img
              src={profileImage || "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%231d93ca'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z'/%3E%3C/svg%3E"}
              alt="Profile"
              className="profile-picture"
            />
            <div className="profile-picture-info">
              <h2>Profile picture</h2>
              <p>PNG, JPEG under 5MB</p>
            </div>
          </div>
          <div className="profile-picture-buttons">
            <input
              type="file"
              id="profileImageUpload"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleImageUpload}
            />
            <label htmlFor="profileImageUpload" className="upload-button">
              Upload new picture
            </label>
            <button className="delete-button" onClick={handleDeleteImage}>Delete</button>
          </div>
        </div>

        <form onSubmit={handleSaveChanges}>
          <div className="form-section">
            <h2>Account Details</h2>
            <p className="subtitle">Manage your account details.</p>
            <div className="account-inputs">
              <div className="input-group">
                <label htmlFor="firstName">First name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  required
                  placeholder="John"
                  value={formData.firstName || ""}
                  onChange={handleInputChange}
                />
              </div>
              <div className="input-group">
                <label htmlFor="lastName">Last name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  required
                  placeholder="Doe"
                  value={formData.lastName || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="account-inputs">
            <div className="input-group">
              <div className="employer-phone-number">
                <label htmlFor="phoneNumber">Phone Number</label>
                <div className="phone-input-container">
                  <PhoneInput
                    id="phoneNumber"
                    name="phoneNumber"
                    international
                    defaultCountry="US"
                    value={formData.phoneNumber}
                    onChange={(phone) => setFormData({ ...formData, phoneNumber: phone })}
                    placeholder="Phone Number"
                  />
                </div>
                </div>
              </div>
              <div className="input-group">
                <label htmlFor="officialTitle">Official title</label>
                <input
                  type="text"
                  id="officialTitle"
                  name="officialTitle"
                  required
                  placeholder="Official Job Title"
                  value={formData.jobTitle || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>Company Details</h2>
            <p className="subtitle">Manage your company's information.</p>
            <div className="account-inputs">
              <div className="input-group">
                <label htmlFor="companyName">Company name</label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  required
                  placeholder="XYZ Ltd."
                  value={formData.companyName || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="account-inputs">
              <div className="input-group">
                <label htmlFor="companyURL">Company URL</label>
                <input
                  type="url"
                  id="companyURL"
                  name="companyURL"
                  required
                  placeholder="https://www.xyzlimited.com"
                  value={formData.companyURL || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="account-inputs">
              <div className="input-group">
                <label htmlFor="glassdoorURL">Glassdoor URL</label>
                <input
                  type="url"
                  id="glassdoorURL"
                  name="glassdoorURL"
                  placeholder="https://www.glassdoor.com/company/xyz-ltd"
                  value={formData.glassdoorURL || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="account-inputs">
              <div className="input-group">
                <label htmlFor="linkedinURL">LinkedIn URL</label>
                <input
                  type="url"
                  id="linkedinURL"
                  name="linkedinURL"
                  placeholder="https://www.linkedin.com/company/xyz-ltd"
                  value={formData.linkedinURL || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>Contact email</h2>
            <p className="subtitle">Manage your account's email address.</p>
            <div className="email-section">
              <div className="input-group">
                <label htmlFor="email">Email</label>
                <div className="email-input-wrapper">
                  <EmailIcon />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    placeholder={`john.doe@mail.com`}
                    value={formData.email || ""}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form-section">
            <h2>Password</h2>
            <p className="subtitle">Modify your current password.</p>
            <div className="password-inputs">
              <div className="input-group">
                <label htmlFor="currentPassword">Current password</label>
                <div className="password-input-wrapper">
                  <LockIcon />
                  <input
                    type={showCurrentPassword ? "text" : "password"}
                    id="currentPassword"
                    name="currentPassword"
                    required
                    placeholder="•••••••••"
                    value={formData.currentPassword}
                    onChange={handleInputChange}
                  />
                  <span
                    className="visibility-icon"
                    onClick={() => togglePasswordVisibility("currentPassword")}
                  >
                    {showCurrentPassword ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </span>
                </div>
              </div>
              <div className="input-group">
                <label htmlFor="newPassword">New password</label>
                <div className="password-input-wrapper">
                  <LockIcon />
                  <input
                    type={showNewPassword ? "text" : "password"}
                    id="newPassword"
                    name="newPassword"
                    placeholder="•••••••••"
                    value={formData.newPassword}
                    onChange={handleInputChange}
                  />
                  <span
                    className="visibility-icon"
                    onClick={() => togglePasswordVisibility("newPassword")}
                  >
                    {showNewPassword ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button type="submit" className="save-changes-button">
            Save changes
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmployerProfilePage;
